// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/registri-contabili?societaId=',
    requestBody: null,
    response: '{ success: true, data: [{ id, societaId, codice, descrizione, ultimoNumero, ultimoAnno, attivo, note }] }'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
